export default __webpack_public_path__ + "static/media/Til.7c2983ed.jpg";